import React from "react";
import { SvgIcon, SvgIconProps } from "@mui/material";
const AppIconsHeatSettings = React.forwardRef(
  (props: SvgIconProps, ref: any) => {
    return (
      <SvgIcon {...props} ref={ref}>
        <g fill="currentColor">
          <path d="M5.8000135,17h11.7999983V7H5.8000135V17z M6.4000125,7.700006h10.3999825v8.599987H6.4000125V7.700006z" />
          <polygon
            points="0.5000011,10.4000044 3.6000073,13.5000105 0.7000166,13.5000105 0.7000166,14.100009 5.1000061,14.100009 
		5.1000061,13.5000105 4.5000057,13.5000105 1.6000165,10.5000124 4.200006,10.5000124 5.1000061,11.4000111 5.1000061,9.800005 
		0.5000011,9.800005 	"
          />
          <path
            d="M10.3000097,10.200036v-0.0000229c-0.6000004-0.6000004-1.399992-1.399992-1.399992-1.399992L8.3000193,9.2000294
		c0,0,0.1000071,0.1000071,1.3000059,1.3000059l-1.4999981,1.499999l1.4999981,1.499999l-1.1999989,1.1999989l0.4999914,0.4999924
		l1.6999922-1.6999912l-1.499999-1.499999l1.499999-1.499999L10.3000097,10.200036z"
          />
          <path
            d="M12.8999996,10.200036v-0.0000229c-0.5999985-0.6000004-1.3999901-1.399992-1.3999901-1.399992l-0.6000004,0.4000082
		c0,0,0.100008,0.1000071,1.3000059,1.3000059l-1.4999981,1.499999l1.4999981,1.499999l-1.1999989,1.1999989l0.4999914,0.4999924
		l1.6999922-1.6999912l-1.499999-1.499999l1.499999-1.499999L12.8999996,10.200036z"
          />
          <path
            d="M15.5999966,10.200036v-0.0000229c-0.5999985-0.6000004-1.399992-1.399992-1.399992-1.399992l-0.5999985,0.4000082
		c0,0,0.100008,0.1000071,1.3000059,1.3000059l-1.499999,1.499999l1.499999,1.499999l-1.1999989,1.1999989l0.4999914,0.4999924
		l1.6999912-1.6999912l-1.4999981-1.499999l1.4999981-1.499999L15.5999966,10.200036z"
          />
          <path
            d="M23.4999981,10.4000282V9.8000278h-5.2000027v0.7000074h0.4999924l0.4000072,0.4000082l-0.8999996,0.8999987v0.8999996
		l0.7000065,0.7000074h-0.7000065v0.7000074h5.2000027v-0.7000074h-0.7000065l-1.1999989-1.1999998l0.8999996-1.0000067v-0.0000229
		l1.0000057,1.0000067v-1.0000067l-0.4999905-0.4999914l0.2999992-0.3000002H23.4999981z M18.7999878,12.2000036
		l0.8999996-0.8999996l0.8999996,0.8999996l-0.8999996,0.9000006L18.7999878,12.2000036z M21.799984,13.5000105h-1.4999981
		l0.7999916-0.7999916L21.799984,13.5000105z M21.1000023,11.7000122l-0.9000015-0.9000006l0.4000092-0.4000063h1.1999989
		l0.2999992,0.3000002L21.1000023,11.7000122z"
          />
        </g>
      </SvgIcon>
    );
  }
);

export default AppIconsHeatSettings;
